import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export const useRecentSearchesAnalytics = (recentSearches) => {
  const { pathname } = useLocation();
  const { setAdobePageData } = useContext(MktgDataContext);
  const recentSearchesType = [];

  useEffect(() => {
    if (pathname === ROUTES.vacations && recentSearches.length) {
      const impressions = [];
      const recentSearchesDestination = [];
      const recentsearchcount = recentSearches?.length.toString();
      let adobeAnalyticsObj = {};

      recentSearches.forEach((search, index) => {
        adobeAnalyticsObj = {
          productcarousel: "My Recent Searches",
          productcode: "",
          productdestination: search?.formData?.destinationAirportCode ?? "",
          productorigin: search?.formData?.originationAirportCode ?? "",
          productposition: `${index + 1}|${recentSearches.length}`,
          productprice: "",
          producttype: getProductType(search),
        };
        recentSearchesDestination.push(
          `${adobeAnalyticsObj.productorigin}-${adobeAnalyticsObj.productdestination}`
        );
        recentSearchesType.push(adobeAnalyticsObj.producttype);
        impressions.push(adobeAnalyticsObj);
      });

      setAdobePageData(
        {
          recentsearchcount,
        },
        "recentSearches",
        impressions
      );
    }
  }, [recentSearches.length]);

  function getProductType(search) {
    const combinedProductType = search?.type;
    const productType = combinedProductType?.split(/(?=[A-Z])/).join("+") ?? "";

    return productType;
  }
};
